module.exports = __webpack_public_path__ + "static/double_bladed_scimitar-004374eab5a5797f5f6f77663920d7e2.png";